import type { UserRole } from "@/types";

export const ROLE_HIERARCHY: Record<UserRole, number> = {
  VIEWER: 0,
  ANALYST: 1,
  INVESTIGATOR: 2,
  RESEARCHER: 3,
  ADMIN: 4,
};

export const ROLE_LABELS: Record<UserRole, string> = {
  ADMIN: "관리자",
  RESEARCHER: "연구자",
  INVESTIGATOR: "수사관",
  ANALYST: "분석관",
  VIEWER: "열람자",
};

export function hasMinRole(userRole: UserRole, requiredRole: UserRole): boolean {
  return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
}

export interface UserPermissions {
  // User management
  canManageUsers: boolean;
  // Cases
  canCreateCases: boolean;
  canDeleteCases: boolean;
  // Samples
  canCreateSamples: boolean;
  canDeleteSamples: boolean;
  // Analyses
  canRunAnalysis: boolean;
  canDeleteAnalysis: boolean;
  // Reports
  canCreateReports: boolean;
  canDeleteReports: boolean;
  // Deargen AI
  canUseDeargenAI: boolean;
  /** T2-3: 후보 판정 기록 (분석관 이상). */
  canAssessCandidates: boolean;
}

export function getPermissions(role: UserRole): UserPermissions {
  return {
    canManageUsers: hasMinRole(role, "ADMIN"),
    canCreateCases: hasMinRole(role, "INVESTIGATOR"),
    canDeleteCases: hasMinRole(role, "RESEARCHER"),
    canCreateSamples: hasMinRole(role, "ANALYST"),
    canDeleteSamples: hasMinRole(role, "INVESTIGATOR"),
    canRunAnalysis: hasMinRole(role, "ANALYST"),
    canAssessCandidates: hasMinRole(role, "ANALYST"),
    canDeleteAnalysis: hasMinRole(role, "INVESTIGATOR"),
    canCreateReports: hasMinRole(role, "ANALYST"),
    canDeleteReports: hasMinRole(role, "INVESTIGATOR"),
    canUseDeargenAI: hasMinRole(role, "ANALYST"),
  };
}
